import React, { Component } from 'react';
import {
    Container, Grid, Segment, Header, Table, Label, Button, Image, List, Loader
} from 'semantic-ui-react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
    // deleteOutpatientClaims,
    // getSingleOutpatientClaim,
    getHradminEmployeeOutpatientClaimData
} from '../../../actions';
import ClaimStatusLabel from '../../../component/claim/claim_status_label';

class HradminEmployeeViewClaimDetailOutPage extends Component {
    state = {
        selectedAttachmentId: null,
        viewUrl: null,
        openDeleteDialog: false,
        deleteThisClaim: false,
        deleteThisClaimResult: null,
    }
    componentDidMount() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const {uuid} = this.props.match.params;
        const {accessToken} = this.props.user;
        this.props.getHradminEmployeeOutpatientClaimData({
            transactionNo: claimTransactionNo,
            userId: uuid,
            accessToken
        });
        // if (!this.props.viewedClaims[claimTransactionNo]) {
        //     console.log('Record Does Not Exist! Fetch Data Now');
        //     this.props.getSingleOutpatientClaim({
        //         accessToken: this.props.user.accessToken,
        //         transactionNo: claimTransactionNo
        //     });
        // } else {
        //     console.log('Record Exists!', this.props.viewedClaims[claimTransactionNo]);
        // }
    }
    setSelectedAttachmentId(attachmentId, viewUrl) {
        this.setState({selectedAttachmentId: attachmentId, viewUrl});
    }
    renderAttachmentList(attachments) {
        return _.map(attachments, (attachment, index) => {
            const { filename, viewUrl } = attachment;
            console.log(attachment);
            return (
                <List.Item key={filename}>
                    <List.Content floated='right'>
                        <Button
                            onClick={() => this.setSelectedAttachmentId(filename, viewUrl)}
                            disabled={this.state.selectedAttachmentId === filename}
                        >
                            View
                        </Button>
                    </List.Content>
                    <List.Content>
                        <Label color='red' horizontal>
                            IMG
                        </Label>
                        Uploaded Document {index + 1}
                    </List.Content>
                </List.Item>
            );
        });
    }
    renderSelectedAttachment() {
        if (this.state.selectedAttachmentId && this.state.viewUrl) {
            return (
                <Image src={this.state.viewUrl} />
            );
        }
    }
    render() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const targetUuid = this.props.match.params.uuid;
        const selectedOutpatientClaim = this.props.employeeClaimData;
        console.log(claimTransactionNo, this.props.selectedClaimToView, targetUuid, this.props.selectedEmployeeToView);
        if (!selectedOutpatientClaim || claimTransactionNo !== this.props.selectedClaimToView || targetUuid !== this.props.selectedEmployeeToView) {
            return (
                <Loader active />
            );
        }
        const {
            transactionNo,
            status,
            remarks,
            submissionDate,
            originalAmount,
            payableAmount,
            benefitName,
            receiptNo,
            providerName,
            visitDate,
            attachment,
            name
        } = selectedOutpatientClaim;
        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    Claim Details - {transactionNo}
                </Header>
                <Grid columns={2}>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Status
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Status
                                        </Table.Cell>
                                        <Table.Cell>
                                            <ClaimStatusLabel status={status} />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Remarks
                                        </Table.Cell>
                                        <Table.Cell>
                                            {remarks || 'No Remarks'}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claimant
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Name
                                        </Table.Cell>
                                        <Table.Cell>
                                            {name}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claim Details
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Transaction No
                                        </Table.Cell>
                                        <Table.Cell>
                                            {transactionNo}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Claimable Amount
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color='green' horizontal>
                                                {originalAmount.currency}
                                            </Label>
                                            {originalAmount.amount.toFixed(2)}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Payable Amount
                                        </Table.Cell>
                                        <Table.Cell>
                                            { (payableAmount) ? (
                                                <div>
                                                    <Label color='green' horizontal>
                                                        {originalAmount.currency}
                                                    </Label>
                                                    {payableAmount}
                                                </div>
                                            ) : 'Pending'}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Benefit
                                        </Table.Cell>
                                        <Table.Cell>
                                            {benefitName}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Visit Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            {visitDate}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Receipt/Invoice No
                                        </Table.Cell>
                                        <Table.Cell>
                                            {receiptNo}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Provider Name
                                        </Table.Cell>
                                        <Table.Cell>
                                            {providerName}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment.Group>
                            <Header as='h4' attached='top' block>
                                Documents
                            </Header>
                            <Segment attached>
                                <List divided>
                                    {this.renderAttachmentList(attachment)}
                                </List>
                            </Segment>
                            <Segment attached>
                                {this.renderSelectedAttachment()}
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        employeeClaimData: state.hradmin.employeeClaimData,
        selectedEmployeeToView: state.hradmin.selectedEmployeeToView,
        selectedClaimToView: state.hradmin.selectedClaimToView,
    }
}

export default connect(mapStateToProps, {
    getHradminEmployeeOutpatientClaimData,
})(HradminEmployeeViewClaimDetailOutPage);
